import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { KeyOutlined, ApiOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const { appId, appSecret } = values;
      
      // 保存认证信息到 localStorage
      localStorage.setItem('appId', appId);
      localStorage.setItem('appSecret', appSecret);
      localStorage.setItem('isAuthenticated', 'true');
      
      // 跳转到主页
      navigate('/diagnosis-hx');
      
      message.success('登录成功');
    } catch (error) {
      message.error('登录失败：' + error.message);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img src="/logo.png" alt="logo" className="login-logo" />
          <h2>库叮智能AI预测平台</h2>
        </div>
        
        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="appId"
            rules={[{ required: true, message: '请输入 APP ID' }]}
          >
            <Input
              prefix={<ApiOutlined />}
              placeholder="请输入 APP ID"
            />
          </Form.Item>

          <Form.Item
            name="appSecret"
            rules={[{ required: true, message: '请输入 APP SECRET' }]}
          >
            <Input.Password
              prefix={<KeyOutlined />}
              placeholder="请输入 APP SECRET"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              登 录
            </Button>
          </Form.Item>
        </Form>

        <div className="login-footer">
          <p>请使用您的 API 密钥进行登录</p>
          <p>如需帮助，请联系系统管理员</p>
        </div>
      </div>
    </div>
  );
};

export default Login; 